import React from "react";
import { View, StyleSheet, FlatList, Animated } from "react-native";
import color from "@constants/color";
import { SearchPillSkelaton } from "./FilterChips";

const _keyExtractor1 = (item) => `${item?.l1_filter_display_text}`;

const _keyExtractor2 = (item) => `${item?.l2_filter_display_text}`;

const FiltersStrip = ({
  l1FilterResults,
  l2FilterResults,
  width,
  renderItemFilterL2,
  renderItemFilterL1,
  loading,
  translateY,
}) => {
  return (
    <Animated.View
      style={[
        styles.container,
        {
          transform: [{ translateY }],
        },
      ]}
    >
      {!l1FilterResults.current ? (
        <SearchPillSkelaton />
      ) : (
        <FlatList
          renderItem={renderItemFilterL1}
          keyExtractor={_keyExtractor1}
          data={l1FilterResults.current}
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          style={{ width, backgroundColor: "transparent" }}
          contentContainerStyle={
            l1FilterResults.current.length >= 1
              ? [styles.chipBox, styles.transparentBackground]
              : {}
          }
        />
      )}
      {loading && !l2FilterResults?.current ? (
        <View style={styles.whiteBackground}>
          <SearchPillSkelaton />
        </View>
      ) : (
        <>
          {l2FilterResults?.current?.length > 0 &&
          l1FilterResults?.current?.length > 0 ? (
            <View style={[styles.dashedBorder, { width: width - 24 }]} />
          ) : null}

          <FlatList
            keyExtractor={_keyExtractor2}
            renderItem={renderItemFilterL2}
            data={l2FilterResults.current}
            horizontal={true}
            showsHorizontalScrollIndicator={false}
            style={{ width, backgroundColor: "transparent" }}
            contentContainerStyle={
              l2FilterResults.current?.length >= 1
                ? [styles.chipBox, styles.additionalPadding]
                : {}
            }
          />
        </>
      )}
    </Animated.View>
  );
};

export default FiltersStrip;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    // paddingBottom: 0,
    backgroundColor: color.white,
  },

  chipBox: {
    paddingTop: 12,
    paddingLeft: 10,
    paddingBottom: 8,
  },
  transparentBackground: {
    backgroundColor: "transparent",
    paddingTop: 10,
    paddingRight: 20,
  },
  whiteBackground: {
    backgroundColor: color.white,
  },
  dashedBorder: {
    borderBottomWidth: 1,
    borderColor: color.borderBox,
    borderStyle: "dashed",
  },
  additionalPadding: {
    paddingTop: 10,
    paddingRight: 20,
  },
});
